import React from "react";
import { Document, Page, StyleSheet, Font } from "@react-pdf/renderer";
import Cover from "../../Components/GeneratePdf/Cover";
import LeadershipPage1 from "../../Components/GeneratePdf/Leadership/LeadershipPage1";
import LeadershipPage2 from "../../Components/GeneratePdf/Leadership/LeadershipPage2";
import LeadershipPage3 from "../../Components/GeneratePdf/Leadership/LeadershipPage3";
import MindSetPage from "../../Components/GeneratePdf/MindSetPage";
import MindSetPage2 from "../../Components/GeneratePdf/MindSetPage2";
import MindSetPage3 from "../../Components/GeneratePdf/MindSetPage3";
import AccToPageHeading from "../../Components/GeneratePdf/AccToPageHeading";
import HeartPage from "../../Components/GeneratePdf/HeartPage";
import RelectAndIntegrate1 from "../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate1";
import RelectAndIntegrate2 from "../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate2";
import LifeIntegration1 from "../../Components/GeneratePdf/LifeIntegration/LifeIntegration1";
import LifeIntegration2 from "../../Components/GeneratePdf/LifeIntegration/LifeIntegration2";
import SoulPage from "../../Components/GeneratePdf/SoulPage";
import MindPage from "../../Components/GeneratePdf/MindPage";
import StrengthPage from "../../Components/GeneratePdf/StrengthPage";
import TableContent from "../../Components/GeneratePdf/SelfReport/TableContent";
import Overview from "../../Components/GeneratePdf/SelfReport/Overview";
import AboutReportFirst360 from "../../Components/Report360/AboutReportFirst360";
import AboutReportSecond360 from "../../Components/Report360/AboutReportSecond360";
import HomeFirst from "../../Components/GeneratePdf/SelfReport/HomeFirst";
import FourQuadrantPage from "../../Components/GeneratePdf/SelfReport/FourQuadrantPage";
import StarterQuadrantChart360 from "../../Components/Report360/StarterQuardrantChart360";
import HeartStarter from "../../Components/GeneratePdf/SelfReport/HeartStarter";
import QuadrantFlowHome from "../../Components/GeneratePdf/SelfReport/QuadrantFlowHome";
import QuadrantFlowFirstPage360 from "../../Components/Report360/QuadrantFlowFirstPage360";
import QuadrantFlowSecondPage360 from "../../Components/Report360/QuadrantFlowSecondPage360";
import QuadrantFlowItemFirst360 from "../../Components/Report360/QuadrantFlowItemFirst360";
import QuadrantFlowItemSecond360 from "../../Components/Report360/QuadrantFlowItemSecond360";
import QuadrantFlowItemThird360 from "../../Components/Report360/QuadrantFlowItemThirdPage360";
import QuadrantFlowHeart360 from "../../Components/Report360/QuadrantFlowHeart360";
import QuadrantFlowSoul360 from "../../Components/Report360/QuadrantFlowSoul360";
import QuadrantFlowMind360 from "../../Components/Report360/QuadrantFlowMind360";
import QuadrantFlowStrength360 from "../../Components/Report360/QuadrantFlowStrength360";
import LeadershipStyleChart360 from "../../Components/Report360/LeadershipStyleChart360";
import LeadershipStyleCollaborative360 from "../../Components/Report360/LeadershipStyleCollaborative360";
import LeadershipFlow360 from "../../Components/Report360/LeadershipFlow360";
import LeadershipFlowDetails360 from "../../Components/Report360/LeadershipFlowDetail360";
import LeadershipItemFirst360 from "../../Components/Report360/LeadershipItemFirst360";
import LifeIntegration3 from "../../Components/GeneratePdf/SelfReport/LifeIntegration3";
import AccToPageHeadingTwo from "../../Components/GeneratePdf/SelfReport/AccToPageHeadingTwo";
import CollaborativePage from "../../Components/GeneratePdf/Leadership/CollaborativePage";
import VisionaryPage from "../../Components/GeneratePdf/Leadership/VisionaryPage";
import StrategicPage from "../../Components/GeneratePdf/Leadership/StrategicPage";
import PerformancePage from "../../Components/GeneratePdf/Leadership/PerformancePage";
import LeadershipCollaborativeInFocus360 from "../../Components/Report360/LeadershipCollaborativeInFocus360";
import LeadershipVisionaryInFocus360 from "../../Components/Report360/LeadershipVisionaryInFocus360";
import LeadershipStrategicInFocus360 from "../../Components/Report360/LeadershipStrategicInFocus360";
import LeadershipPerformanceInFocus360 from "../../Components/Report360/LeadershipPerformanceInFocus360";
import LeadershipItemSecond360 from "../../Components/AssessmentDetail/Reports/report360-pdf/LeadershipItemSecond360";
import LeadershipItemThird360 from "../../Components/AssessmentDetail/Reports/report360-pdf/LeadershipItemThird360";
import GapAnalysisPage from "../../Components/GeneratePdf/Leadership/GapAnalysisPage";
import GapAnalysisPageTwo from "../../Components/GeneratePdf/Leadership/GapAnalysisPageTwo";
import LeadershipItemSecondPdf360 from "../../Components/Report360/LeadershipItemSecondPdf360";
import LeadershipItemThirdPdf360 from "../../Components/Report360/LeadershipItemThirdPdf360";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import { calculatePageNumbers } from "../../utils/helper";

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 30,
  },
  page2: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 20,
  },
  pagespace: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 21,
    height: 792,
    justifyContent: "space-between",
  },
});

// Map menu keys to their corresponding pages for 360 assessment
const pageComponentMap = {
  "Cover Page": [
    { component: Cover, style: styles.page }
  ],
  "Table of Contents": [
    { component: (props) => <TableContent {...props} pageNumbers={calculatePageNumbers(props.menuItems, pageComponentMap)} />, style: styles.page }
  ],
  "Overview": [
    { component: Overview, style: styles.page }
  ],
  "Summary Snapshot": [
    { component: AboutReportFirst360, style: styles.page },
    { component: AboutReportSecond360, style: styles.page }
  ],
  // Starter Quadrant Section
  "Starter Quadrant": [
    { component: HomeFirst, style: styles.page }
  ],
  "Four Quadrants": [
    { component: FourQuadrantPage, style: styles.page }
  ],
  "Starter Quadrant Chart": [
    { component: StarterQuadrantChart360, style: styles.page }
  ],
  "Results": [
    { component: HeartStarter, style: styles.page }
  ],
  // Quadrant Flow Section
  "HomeQuadrantFlow": [
    { component: QuadrantFlowHome, style: styles.page }
  ],
  "Introduction": [
    { component: QuadrantFlowFirstPage360, style: styles.page }
  ],
  "Quadrant Flow": [
    { component: QuadrantFlowSecondPage360, style: styles.page }
  ],
  "QFItemOnePage": [
    { component: QuadrantFlowItemFirst360, style: styles.page2 },
    { component: QuadrantFlowItemSecond360, style: styles.page2 },
    { component: QuadrantFlowItemThird360, style: styles.page2 }
  ],
  // Quadrant In Focus
  "Heart": [
    { component: QuadrantFlowHeart360, style: styles.page2 }
  ],
  "Soul": [
    { component: QuadrantFlowSoul360, style: styles.page2 }
  ],
  "Mind": [
    { component: QuadrantFlowMind360, style: styles.page2 }
  ],
  "Strength": [
    { component: QuadrantFlowStrength360, style: styles.page2 }
  ],
  // Leadership Style Section
  "Home Leadership Style": [
    { component: LeadershipPage1, style: styles.pagespace }
  ],
  "Leadership Style Introduction": [
    { component: LeadershipPage2, style: styles.pagespace }
  ],
  "Leadership Style Chart": [
    { component: LeadershipStyleChart360, style: styles.pagespace }
  ],
  "Leadership Style Results": [
    { component: LeadershipStyleCollaborative360, style: styles.pagespace }
  ],
  // Leadership Flow Section
  "Leadership Flow Introduction": [
    { component: LeadershipFlow360, style: styles.pagespace }
  ],
  "Leadership Flow Results": [
    { component: LeadershipFlowDetails360, style: styles.pagespace }
  ],
  "Items Overview Leadership 360": [
    { component: LeadershipItemFirst360, style: styles.pagespace },
    { component: LeadershipItemSecondPdf360, style: styles.pagespace },
    { component: LeadershipItemThirdPdf360, style: styles.pagespace }
  ],
  // Leadership Style In Focus
  "Collaborative": [
    { component: LeadershipCollaborativeInFocus360, style: styles.pagespace }
  ],
  "Visionary": [
    { component: LeadershipVisionaryInFocus360, style:  styles.pagespace }
  ],
  "Strategic": [
    { component: LeadershipStrategicInFocus360, style: styles.pagespace }
  ],
  "Performance": [
    { component: LeadershipPerformanceInFocus360, style: styles.pagespace }
  ],
  //Alignment Section
  "Alignment": [
    { component: GapAnalysisPage, style: styles.page2 },
    { component: GapAnalysisPageTwo, style: styles.page2 }
  ],
  // Mindset Section
  "Home Mindset": [
    { component: MindSetPage, style: styles.page2 }
  ],
  "Mindset Introduction": [
    { component: MindSetPage2, style: styles.page2 }
  ],
  "Mindset Results": [
    { component: MindSetPage3, style: styles.page2 }
  ],
  // Reflect and Integrate Section
  "Home Reflect And Integrate": [
    { component: RelectAndIntegrate1, style: styles.page2 }
  ],
  "Reflect and Integrate": [
    { component: RelectAndIntegrate2, style: styles.page2 }
  ],
  "Life Integration": [
    { component: LifeIntegration1, style: styles.page2 }
  ],
  "Leadership Integration": [
    { component: LifeIntegration3, style: styles.page2 }
  ],
  "Final Thoughts": [
    { component: LifeIntegration2, style: styles.page2 }
  ]
};

export default function MyDocument360({ apiData, menuItems }) {
 
  const findActiveMenuItems = (items) => {
    const activeItems = new Set();
    const processedItems = new Set(); 
    
    const processItem = (item) => {
      if (processedItems.has(item.key)) {
        return;
      }
      
      processedItems.add(item.key);

      if (item.isActive) {
        activeItems.add(item.key);
        
        if (item.subMenu) {
          item.subMenu.forEach(subItem => {
            if (!processedItems.has(subItem.key)) {
              activeItems.add(subItem.key);
              processItem(subItem);
            }
          });
        }
      } 
      else if (item.subMenu) {
        item.subMenu.forEach(subItem => processItem(subItem));
      }
    };

    items?.forEach(item => processItem(item));
    return Array.from(activeItems);
  };

  const renderPage = (key, config, index) => {
    try {
      const Component = config.component;
      return (
        <Page 
          key={`${key}-${index}`} 
          size={{ width: 612, height: 792 }} 
          style={config.style}
        >
          <Component apiData={apiData} menuItems={menuItems} />
        </Page>
      );
    } catch (error) {
      console.error(`Error rendering page ${key}:`, error);
      return null;
    }
  };
  const renderedPages = new Set();
  const pages = [
    <Page key="cover" size={{ width: 612, height: 792 }} style={styles.page}>
      <Cover apiData={apiData} />
    </Page>
  ];

  const activeMenuKeys = findActiveMenuItems(menuItems || []);

  activeMenuKeys.forEach(key => {
    const pageConfigs = pageComponentMap[key];
    
    if (pageConfigs) {
      pageConfigs.forEach((config, index) => {
        const pageKey = `${key}-${config.component.name}`;
        if (!renderedPages.has(pageKey)) {
          const page = renderPage(key, config, index);
          if (page) {
            pages.push(page);
            renderedPages.add(pageKey);
          }
        }
      });
    }
  });

  return (
    <Document>
      {pages}
    </Document>
  );
}